import React from 'react';

const MediaHeader = ({ title, englishTitle, japaneseTitle, synonyms = [] }) => {
  return (
    <div className="titles">
      <h1>{title}</h1>
      {englishTitle && <h2>{englishTitle}</h2>}
      {japaneseTitle && <h3>{japaneseTitle}</h3>}
      {synonyms?.length > 0 && (
        <div className="alt-titles">
          Also known as: {synonyms.join(', ')}
        </div>
      )}
    </div>
  );
};

export default MediaHeader;